/** Cents to a dollar price for copy: 499 → '$4.99'. */
export function formatUsd(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

/** Cents to a price for a headline: whole dollars drop the cents, 19900 → '$199'. */
export function formatPrice(cents: number): string {
  return cents % 100 === 0 ? `$${cents / 100}` : formatUsd(cents);
}
